/**
 * Public barrel export for the LabelPill molecule (SE-5527).
 * @module components/molecules/LabelPill
 */
export { default } from "./LabelPillView";
export type { LabelPillProps } from "./LabelPillView";
